import { useEffect, useState } from "react";
import { useDispatch } from "react-redux"; //中间件
import { getUnitList } from "./store/modules/unitStore";
import { Layout } from "antd";
import { Outlet } from "react-router-dom";
import HeaderBar from "./layout/HeaderBar";
import SiderBar from "./layout/SideBar";
import "./App.scss";

// 渲染路径： app.js -> index.js -> public/index.html
function App() {
  //注入store
  // const dispatch = useDispatch();
  // useEffect(() => {
  //   dispatch(getUnitList());
  // }, [dispatch]);

  const { Header, Sider, Content } = Layout; //解构
  const [collapsed, setCollapsed] = useState(false);
  return (
    <Layout>
      <Header>
        <HeaderBar collapsed={collapsed} setCollapsed={setCollapsed} />
      </Header>
      <Layout>
        <Sider
          collapsible // 允许折叠
          collapsed={collapsed} // 折叠状态
          onCollapse={(value) => setCollapsed(value)} // 折叠状态变化时的回调
          width={200} // 展开时的宽度
          collapsedWidth={80} // 折叠时的宽度
        >
          <SiderBar collapsed={collapsed} />
        </Sider>
        <Content>
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  );
}

export default App;
